import { Component } from "react";

const APP_CRASH_KEY = "app_crash_trace";
const SWITCH_TRACE_KEY = "switch_to_mobile_trace";

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "Unknown application error",
    };
  }

  componentDidCatch(error, errorInfo) {
    try {
      const payload = {
        at: new Date().toISOString(),
        message: error?.message || "Unknown application error",
        stack: error?.stack || "",
        componentStack: errorInfo?.componentStack || "",
      };
      sessionStorage.setItem(APP_CRASH_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    let persisted = null;
    let switchTrace = null;
    try {
      persisted = JSON.parse(sessionStorage.getItem(APP_CRASH_KEY) || "null");
      switchTrace = JSON.parse(
        sessionStorage.getItem(SWITCH_TRACE_KEY) || "null"
      );
    } catch (e) {}

    const stack = persisted?.stack || "";
    const componentStack = persisted?.componentStack || "";
    const location =
      typeof window !== "undefined"
        ? `${window.location.pathname}${window.location.search}`
        : "";

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily: "sans-serif",
          color: "#1f2937",
          textAlign: "center",
          background: "#ffffff",
        }}
      >
        <div>
          <h2>Application error</h2>
          <p>The application encountered an unexpected error.</p>
          <p>{this.state.message}</p>
          <p style={{ marginTop: "12px", fontSize: "12px" }}>Location: {location}</p>
          {!!stack && (
            <pre
              style={{
                textAlign: "left",
                whiteSpace: "pre-wrap",
                maxWidth: "92vw",
                marginTop: "12px",
                fontSize: "11px",
                background: "#f3f4f6",
                padding: "10px",
                borderRadius: "6px",
              }}
            >
              {stack}
            </pre>
          )}
          {!!componentStack && (
            <pre
              style={{
                textAlign: "left",
                whiteSpace: "pre-wrap",
                maxWidth: "92vw",
                marginTop: "12px",
                fontSize: "11px",
                background: "#f3f4f6",
                padding: "10px",
                borderRadius: "6px",
              }}
            >
              {componentStack}
            </pre>
          )}
          {!!switchTrace && (
            <pre
              style={{
                textAlign: "left",
                whiteSpace: "pre-wrap",
                maxWidth: "92vw",
                marginTop: "12px",
                fontSize: "11px",
                background: "#f3f4f6",
                padding: "10px",
                borderRadius: "6px",
              }}
            >
              {JSON.stringify(switchTrace, null, 2)}
            </pre>
          )}
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;